import React from 'react';

const Locked = () => {
  return (
<svg version="1.1" id="Locked" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20px" height="20px" fill="#0CD428" viewBox="0 0 30 30" style={{ enableBackground: 'new 0 0 30 30' }} xmlSpace="preserve">
  <path
    className="st0"
    d="M24.6,12.7h-2.3V8c0-4-3.2-7.3-7.2-7.3S7.8,4,7.8,8v4.7H5.4c-0.8,0-1.4,0.6-1.4,1.4v13.7c0,0.8,0.6,1.4,1.4,1.4
    h19.1c0.8,0,1.4-0.6,1.4-1.4V14.1C26,13.3,25.3,12.7,24.6,12.7z M11,8c0-2.2,1.8-4,4-4s4,1.8,4,4v4.7h-8V8z"
  />
</svg>

  );
};
export default Locked;
